$(document).ready(function () {
  $(".open-sidebar").on("click", function (e) {
    e.preventDefault();
    $(".product-sidebar").addClass("drawer--is-open");
    $(".sidebar-overlay").addClass("active");
    $("body").addClass("drawer-open-size");
  });

  $(".close-sidebar, .sidebar-overlay").on("click", function () {
    $(".product-sidebar").removeClass("drawer--is-open");
    $(".sidebar-overlay").removeClass("active");
    $("body").removeClass("drawer-open-size");
  });
  $(".image-and-color-name").hover(
    function () {
      var value = $(this).attr("colorsel");

      $(".clrselected").text(value);
    },
    function () {
      setTimeout(function () {
        if ($(".image-and-color-name:hover").length == 0) {
          var value = $(".image-and-color-name.selected").attr("colorsel");
          $(".clrselected").text(value);
        }
      }, 300);
    }
  );
  
// ======== PRODUCT CARD IMAGE SLIDER JS =========

  $(".carousel").flickity({
    // options
    cellAlign: "center",
    contain: false,
    pageDots: false,
    groupCells: 1,
    wrapAround: true,
    prevNextButtons: true,
  });
  
});
